import {Injectable, ViewContainerRef} from '@angular/core';
import {DialogAction, DialogCloseResult, DialogService} from '@progress/kendo-angular-dialog';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {
    RarsPublishDialogComponent
} from '../components/rars-publish-dialog/rars-publish-dialog.component';

/**
 * Opens the review-then-send dialog. Mirrors OverrideDialogService: Kendo
 * component-content dialog, inputs set on the instance.
 */
/** What the user chose to happen after the re-optimization completes. */
export type ReOptSendChoice = 'auto' | 'review' | null;

@Injectable({
    providedIn: 'root'
})
export class RarsPublishDialogService {

    constructor(private dialogService: DialogService) {
    }

    /**
     * Ask what should happen to the affected OD allocations once the
     * re-optimization finishes. Emits 'auto' to send as soon as it completes,
     * 'review' to leave them for the next scheduled run, or null if the user
     * backed out — in which case no re-optimization is started at all.
     */
    public openReOptConfirmDialog(container: ViewContainerRef): Observable<ReOptSendChoice> {
        const dialogRef = this.dialogService.open({
            title: 'Re-Optimize',
            width: 560,
            appendTo: container,
            content:
                'When the re-optimization finishes, send the affected OD allocations to '
                + 'RARS automatically? If not, they stay in FareVantage and will be sent '
                + 'with the next daily or intraday run',
            actions: [
                {text: 'Cancel'},
                {text: 'Allow Review'},
                {text: 'Send Automatically', primary: true}
            ]
        });
        return dialogRef.result.pipe(
            map(result => {
                if (result instanceof DialogCloseResult) {
                    return null;
                }
                switch ((result as DialogAction).text) {
                    case 'Send Automatically':
                        return 'auto';
                    case 'Allow Review':
                        return 'review';
                    default:
                        return null;
                }
            })
        );
    }

    public openReviewDialog(requestId: string, container: ViewContainerRef,
                            publishId?: string): RarsPublishDialogComponent {
        const dialogRef = this.dialogService.open({
            width: 1000,
            height: 640,
            appendTo: container,
            content: RarsPublishDialogComponent
        });
        const dialog = dialogRef.content.instance as RarsPublishDialogComponent;
        dialog.requestId = requestId;
        dialog.publishId = publishId;
        dialog.closed.subscribe(() => dialogRef.close());
        return dialog;
    }
}
